module.exports = __webpack_public_path__ + "fonts/Aclonica-Regular-2.5314dab9.ttf";